module.exports = "https://staticsandbox.coteibem.com.br/assets/logo-color-white-horizontal.f06d7e7a11baec29643a1d6e8130207f.svg";